'use client'

import { OSInfo, parseOSVersion } from './os-common'

export const getOSInfoClient = (): OSInfo => {
  return parseOSVersion(navigator.userAgent || '')
}
